import { ShopFocusType } from '../enums/shop-focus-type.enum'

export interface IShopFocusRequest {
  focusType: ShopFocusType
}
